<script>
  import { races, selectedRaceId } from '../stores';

  function getRaceInfo(raceId) {
    let array = $races.filter(item => item.id == raceId);
    let raceInfo;
    if (array.length > 0) {
      raceInfo = array[0];
      return raceInfo;
    } 
  }

  let raceInfo = getRaceInfo($selectedRaceId);
</script>

<div class="container container-background" style="background-color: #ECEBE7;height:100vh;">
  <div class="row">
    <div>
      <div>
        <div class="wrapper">
          <div class="header text-uppercase" style="color: #3A3A39;background-color: #ECEBE7;font-family: Montserrat,Georgia,'Times New Roman',Times,serif;">
            <div class="widget-49-meeting-info text-center" style="letter-spacing: 1px;">
                <span class="display-6" style="font-weight:900;">{raceInfo.name}</span>
                <span class="fs-6">{raceInfo.location}</span>
                <span class="fw-lighter" style="font-size:12px;">{raceInfo.date}</span>
            </div>
          </div>
          <div class="banner-img">
          {#if !raceInfo.completed}
            <div class="map-responsive" style="padding-bottom:90%;">
              <!--<iframe title="" src="https://www.google.com/maps/d/embed?mid=1MNGYzFCDWFSATe12jEvvRV4utF5Yu02O&ehbc=2E312F" width="600" height="700" frameborder="0" style="border:0; margin-top:-45px;" allowfullscreen></iframe>-->
             <!-- <iframe title="Race Route in Google Maps" src="https://www.google.com/maps/d/embed?mid=1rEpaUhMNwKUBiAA0P6ueh1V0NGDbUXO6&ehbc=2E312F&maptype=satellite" frameborder="0" style="border:0; margin-top:-45px;height: 90vh;" allowfullscreen></iframe>-->
              <iframe title="Race Route in Google Maps" src="https://www.google.com/maps/d/embed?mid=1e-CbHKIgNee2bMavjCI4np0e7CKvlCOF&ehbc=2E312F" frameborder="0" style="border:0; margin-top:-45px;" width="600" height="450" allowfullscreen></iframe>
            </div>
          {/if}
          </div>
          <div style="margin-top: -24px;">
          <div class="dates tile">
              <div class="start">
                  <strong style="font-weight:900;">TIME</strong> {raceInfo.race_time}
                  <span></span>
              </div>
              <div class="ends">
                  <strong>DISTANCE</strong> {raceInfo.distance}km
              </div>
          </div>
          <div class="dates tile">
              <div class="start">
                  <strong>ELEVATION</strong> {raceInfo.elevation}m
                  <span></span>
              </div>
              <div class="ends">
                  <strong>GRADIENT</strong> {raceInfo.gradient}%
              </div>
          </div>
          </div>

          <small class="muted">Distance, Elevation and Gradient obtained from Strava.</small>
        </div>
      </div> 
    </div>
  </div>
</div>
<style>
          /*	Reset & General
    ---------------------------------------------------------------------- */
    * { margin: 0px; padding: 0px; }
    body {
      background: #ECEBE7;
      /*font:14px "Open Sans", sans-serif; */
      
      font: 14px Montserrat,Georgia,'Times New Roman',Times,serif;
      text-align:center;
    }

    .wrapper {
      /*background-color: #fff;*/
      color: #3B3B3A;
      height: 100%;
      /*padding-top:20px;*/
    }

    .tile{
      width: 95%;
      /*background:#fff;*/
      background: #AB8268;
      color: #ECEBE7;
      border-radius:5px;
      box-shadow:0px 2px 3px -1px rgba(151, 171, 187, 0.7);
      /*float:left;*/
      transform-style: preserve-3d;
      margin: 10px auto;
    }

    .header{
      /*border-bottom:1px solid #ebeff2;*/
      padding:25px 0;
      text-align:center;
      color:#59687f;
      font-size:600;
      font-size:19px;	
      position:relative;
      text-align:center;
    }

    .banner-img {
      /*padding: 5px 5px 0;*/
    }

    .dates{
      border:1px solid #ebeff2;
      border-radius:5px;
      padding:20px 0px;
      margin:10px auto;
      font-size:16px;
      font-family: Montserrat,Georgia,'Times New Roman',Times,serif;
      /*color:#5aadef;*/
      color: #ECEBE7;
      font-weight:600;	
      overflow:auto;
    }
    .dates div{
      float:left;
      width:50%;
      text-align:center;
      position:relative;
    }
    .dates strong {
      display:block;
      color:#3B3B3A;
      font-size:12px;
      font-weight:900;
      letter-spacing: 0.1em;
    }
    .dates span{
      width:1px;
      height:40px;
      position:absolute;
      right:0;
      top:0;	
      background:#ebeff2;
      letter-spacing: 0.1em;
    }

    .map-responsive{
      overflow:hidden;
      padding-bottom: 60%;
      height:0;
      position:relative;
    }

    .map-responsive iframe{
        left:0;
        top:0;
        height:100%;
        width:100%;
        position:absolute;
    }

    .widget-49-meeting-info {
      display: flex;
      flex-direction: column;
      margin-left: 1rem;
    }
  </style>